import { Modal } from "antd";
import { FlexBoxVertical } from "common/base/flex-box";
import { useState, type FC } from "react";
import { modalStore } from "store/modal-store";


export interface InitialVisaProfileProps {
    
}
const BasicModal:FC<InitialVisaProfileProps>  = ({}) => {
    const { 
        isOpen, title, content, okText, cancelText, containerStyle, 
        okButtonProps, cancelButtonProps, onOk, onCancel, isClosable, closeModal,
        memory, width,
    } = modalStore();
    const [processing, setProcessing] = useState(false)
    const contentNode = typeof content === "function" ? content(memory) : content;

    return (
        <Modal 
            open={isOpen}
            onCancel={closeModal}
            closable={isClosable}
            loading={processing}
            width={width}
            okButtonProps={{
                style: onOk ? {
                    ...okButtonProps?.style 
                } : { display: "none" },
                onClick(){
                    setProcessing(true)
                    onOk?.().finally(() => {
                        setProcessing(false)
                    })
                },
                disabled: okButtonProps?.disabled || processing,
            }}
            cancelButtonProps={{
                disabled: processing,
                style: onCancel ? {
                    ...cancelButtonProps?.style
                } : { display: "none" },
                onClick: onCancel,
            }}
            {...{ 
                okText: processing ? "Processing..." : okText, 
                cancelText,
                styles: {
                    content: {
                        padding: 30
                    }
                },
            }}
        >
            <FlexBoxVertical flex gap={20} style={containerStyle}>
                {title}
                {contentNode}
            </FlexBoxVertical >
        </Modal>
    )
}

export default BasicModal;
